import { createUrlStore } from "../../../../utils/createUrlStore.ts";
import type { QuickActionCategory } from "../types.ts";

// XXX: We store open state in the URL to be able to open the dialog from a link but also to filter out intercom product tours, banners, ...
export const quickActionsDialogStore = createUrlStore<
  {
    isOpen: boolean | null;
    selectedCategory: QuickActionCategory | null;
    searchText: string;
  },
  {
    open: () => void;
    close: () => void;
    selectCategory: (category: QuickActionCategory | null) => void;
    setSearchText: (searchText: string) => void;
  }
>(
  {
    isOpen: null,
    selectedCategory: null,
    searchText: "",
  },
  {
    isOpen: {
      paramName: "quickActionsOpen",
      serialize: (value) => value?.toString() ?? "",
      deserialize: (value) => value === "true",
    },
  },
  ({ set }) => ({
    open: () => {
      set({ isOpen: true });
    },
    close: () => {
      set({ isOpen: null });
    },
    selectCategory: (category: QuickActionCategory | null) => {
      set({ selectedCategory: category });
    },
    setSearchText: (searchText: string) => {
      set({ searchText });
    },
  }),
);
